import { FormEvent, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { HttpError } from "../api/http";

export default function Login() {
  const { token, login, sessionExpired, clearSessionExpired } = useAuth();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  if (token) {
    return <Navigate to="/" replace />;
  }

  // Reset the "session expired" notice as soon as the user starts typing —
  // they've acknowledged it by interacting with the form, so the banner
  // shouldn't linger once they've moved on to retyping credentials.
  const handleIdentifierChange = (value: string) => {
    setIdentifier(value);
    if (sessionExpired) clearSessionExpired();
  };
  const handlePasswordChange = (value: string) => {
    setPassword(value);
    if (sessionExpired) clearSessionExpired();
  };

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(identifier, password);
    } catch (err) {
      if (err instanceof HttpError && err.status === 401) {
        setError("Credenciales incorrectas");
      } else {
        setError("No se pudo conectar con el backend");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f8f9fb",
      }}
    >
      <form
        onSubmit={handleSubmit}
        style={{
          background: "white",
          padding: "2rem",
          borderRadius: "0.75rem",
          boxShadow: "0 4px 16px rgba(0,0,0,.08)",
          borderLeft: "3px solid #0069d9",
          width: "320px",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <h2 style={{ margin: 0, color: "#2A3F54" }}>Life5 Admin</h2>
        {sessionExpired && (
          <div
            role="status"
            style={{
              background: "#fff3cd",
              color: "#856404",
              border: "1px solid #ffe69c",
              padding: "0.5rem 0.65rem",
              borderRadius: "0.4rem",
              fontSize: ".82rem",
              lineHeight: 1.35,
            }}
          >
            Tu sesión ha expirado. Vuelve a iniciar sesión para continuar.
          </div>
        )}
        <label style={{ fontSize: ".85rem", color: "#73879C" }}>
          Usuario
          <input
            type="text"
            value={identifier}
            onChange={(e) => handleIdentifierChange(e.target.value)}
            required
            autoComplete="username"
            style={{ width: "100%", marginTop: "0.25rem" }}
          />
        </label>
        <label style={{ fontSize: ".85rem", color: "#73879C" }}>
          Contraseña
          <input
            type="password"
            value={password}
            onChange={(e) => handlePasswordChange(e.target.value)}
            required
            autoComplete="current-password"
            style={{ width: "100%", marginTop: "0.25rem" }}
          />
        </label>
        {error && (
          <div style={{ color: "#c00", fontSize: ".85rem" }}>{error}</div>
        )}
        <button type="submit" disabled={loading}>
          {loading ? "Entrando..." : "Entrar"}
        </button>
      </form>
    </div>
  );
}
